import React, { Component } from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { KEYS_CHARCODE, FOOTER_BUTTON_ALIGNMENT, MODAL_CONTROLS_POSITION } from '../consts.js';
import { s as styles } from '../url-input-modal-8ffed82b.js';
import SettingsMobileHeader from '../Components/SettingsMobileHeader.js';
import CloseIcon from '../Icons/CloseIcon.js';
import TextInput from '../Components/TextInput.js';
import SettingsPanelFooter from '../Components/SettingsPanelFooter.js';
import '../style-inject.es-746bb8ed.js';
import '../Components/Button.js';
import 'wix-rich-content-common/libs/Tooltip';
import 'lodash';
import '../Icons/SearchIcon.js';
import '../Icons/ErrorIcon.js';
import '../Components/ActionButtons.js';

class UrlInputModal extends Component {
  constructor(props) {
    super(props);
    this.input = null;
    this.onUrlChange = (url) => {
      this.props.onInputChange(url);
    };
    this.handleKeyPress = (event) => {
      if (event.charCode === KEYS_CHARCODE.ENTER) {
        this.props.onConfirm();
      }
      if (event.charCode === KEYS_CHARCODE.ESCAPE) {
        this.props.onCloseRequested();
      }
    };
    this.state = {
      isDropdownOpen: false
    };
    const { theme = {}, buttonAlignment } = props;
    this.styles = mergeStyles({ styles, theme });
    const endAlignmentStyles = buttonAlignment === FOOTER_BUTTON_ALIGNMENT.END && this.styles.endAlignment;
    const getClassNames = (st) => classNames(st, endAlignmentStyles);
    this.classes = {
      container: getClassNames(styles.urlInput_container),
      headerText: getClassNames(styles.urlInput_header_text),
      closeBtn: getClassNames(styles.urlInput_closeIcon),
      header: getClassNames(styles.urlInput_header),
      input: getClassNames(styles.urlInputModal_textInput),
      topControls: getClassNames(styles.urlInputModal_topControls)
    };
  }
  componentDidMount() {
    if (this.input) {
      this.input.focus();
      this.input.setSelectionRange(0, this.input.value.length);
    }
  }
  render() {
    const {
      t,
      languageDir,
      onConfirm,
      input = "",
      submittedInvalidUrl = false,
      dataHook,
      title,
      errorMessage,
      placeholder,
      onCloseRequested,
      children,
      theme = {},
      buttonAlignment = FOOTER_BUTTON_ALIGNMENT.CENTER,
      controlsPosition = MODAL_CONTROLS_POSITION.BOTTOM,
      selected = true,
      textInput = true,
      buttonSize
    } = this.props;
    const topControls = controlsPosition === MODAL_CONTROLS_POSITION.TOP;
    const { styles: styles2, classes } = this;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, topControls && /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        theme,
        saveLabel: t("EmbedURL_Common_CTA_Primary"),
        cancelLabel: t("EmbedURL_Common_CTA_Secondary"),
        onSave: () => onConfirm(),
        onCancel: () => onCloseRequested(),
        t
      }
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(classes.container, { [classes.topControls]: topControls }),
        "data-hook": dataHook,
        dir: languageDir
      },
      !topControls && /* @__PURE__ */ React.createElement(CloseIcon, { className: classes.closeBtn, onClick: onCloseRequested }),
      /* @__PURE__ */ React.createElement("div", { className: classes.header }, /* @__PURE__ */ React.createElement("div", { className: classes.headerText }, title)),
      /* @__PURE__ */ React.createElement("div", { className: classes.input }, textInput && /* @__PURE__ */ React.createElement(
        TextInput,
        {
          onClick: () => this.setState({ isDropdownOpen: true }),
          inputRef: (ref) => {
            this.input = ref;
          },
          type: "url",
          id: "dropdown-text-input",
          onKeyPress: this.handleKeyPress,
          onChange: this.onUrlChange,
          value: input,
          error: submittedInvalidUrl && errorMessage,
          placeholder,
          theme: styles2,
          "data-hook": `${dataHook}Input`,
          autoComplete: "off",
          searchIcon: textInput == null ? void 0 : textInput.searchIcon
        }
      ), children),
      !topControls && /* @__PURE__ */ React.createElement(
        SettingsPanelFooter,
        {
          save: () => onConfirm(),
          cancel: onCloseRequested,
          saveLabel: t("EmbedURL_Common_CTA_Primary"),
          cancelLabel: t("EmbedURL_Common_CTA_Secondary"),
          theme,
          layoutOptions: { isModal: true, buttonAlignment },
          t,
          selected,
          buttonSize
        }
      )
    ));
  }
}

export { UrlInputModal as default };
//# sourceMappingURL=UrlInputModal.js.map
